import React, { useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import { observable } from 'mobx';
import { swiperOptions } from './swiper-options';

class BaseSwiperStore {
  @observable swiperOptions = swiperOptions.default;

  @observable activeIndex = 0;
  @observable size = 0;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  goNext = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slideNext();
  };

  goPrev = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slidePrev();
  };

  goTo = index => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slideToLoop(index);
  };

  onChange = activeIndex => {
    this.activeIndex = activeIndex;
  };

  isDisabled() {
    return this.size < 2;
  }

  use({ children }) {
    this.size = React.Children.count(children);

    const swiperRef = (this.swiperRef = useRef());
    this.onResize = debounce(() => {
      swiperRef.current?.swiper.update();
    }, 500);

    useEffect(
      () => {
        const onResize = this.onResize;
        window.addEventListener('resize', onResize);
        return () => {
          window.removeEventListener('resize', onResize);
        };
      },
      [this.onResize]
    );

    useEffect(() => {
      const swiper = this.swiperRef.current.swiper;
      const context = this;
      swiper.on('slideChange', function() {
        const newIndex = swiper.realIndex;
        context.activeIndex = newIndex;
        // 调用onChange回调
        context.onChange && context.onChange(newIndex);
      });
    }, []);

    useEffect(
      () => {
        if (this.swiperRef.current.swiper?.realIndex !== this.activeIndex) {
          const swiper = this.swiperRef.current.swiper;
          swiper.slideToLoop(this.activeIndex);
        }
      },
      [this.activeIndex]
    );
  }
}

export default BaseSwiperStore;
